import React from "react";
import StatusCircle from "../../../../components/StatusCircle";
import {CardTitle, Col, Row} from "reactstrap";
import "./index.css";

const TopSectionBroadcastDetail = ({userName, userImage, isTitle, status,broadcast}) => {
    return (
        <React.Fragment>
            <Row className="top-section-broadcast-detail">
                <Col sm="1">
                    <StatusCircle isTitle={isTitle} status={status && status}/>
                    <CardTitle>
                        <img
                            src={userImage}
                            alt="user image"
                            className="rounded-circle mr-2"
                            width="40"
                            height="40"
                        />
                    </CardTitle>
                </Col>
                <Col sm="11" style={{paddingLeft:30}}>
                    <div className="sessiontitle">{broadcast.session_title}</div>
                    <div><span className="sessiontext">{broadcast.session_description}</span></div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default TopSectionBroadcastDetail;
